import React, { FunctionComponent, useState } from "react"
import classnames from "classnames"
import "./sidebar.scss"
import { Drawer } from "@kuali/kuali-ui/lib/drawers"
import { NavList, NavListItem } from "@kuali/kuali-ui/lib/nav-lists"
import { SidebarLinkConfig, SidebarNestedLinkConfig } from "./types"

import ModalUpdateStatus from "../plan-status-update"
import { PrimaryNavLinks } from "./SidebarPrimaryList"
import { SecondaryNavLinks } from "./SidebarSecondaryList"

interface Props {
  associatedContentSelector: string
  isSidebarExpandedByDefault?: boolean
  classNameProps?: string
  primaryLinkData?: Array<SidebarLinkConfig>
  secondaryLinkData?: Array<SidebarNestedLinkConfig>
}

const SidebarNav: FunctionComponent<Props> = ({
  classNameProps,
  associatedContentSelector,
  primaryLinkData,
  secondaryLinkData,
  isSidebarExpandedByDefault = true
}) => {
  const [sidebarIsExpanded, setSidebarState] = useState(isSidebarExpandedByDefault)
  const [isStatusModalOpen, setStatusModalOpen] = useState(false)

  const handleModalClose = () => {
    setStatusModalOpen(false)
  }

  const handleModalOpen = () => {
    setStatusModalOpen(true)
  }

  const handleSidebarClick = (event: React.SyntheticEvent): void => {
    // TODO - this is where we might handle displaying modal for updating plan
    // status. Commenting out until decided
    // event.preventDefault()
    //handleModalOpen()
  }

  const classes = classnames("grayjoy-layout", classNameProps)

  return (
    <nav className={classes}>
      <div className="grayjoy-layout__skipNav">
        <a
          href={associatedContentSelector}
          className="grayjoy-layout__skipNav--link"
        >
          Skip to main content
        </a>
      </div>
      <Drawer
        visible={sidebarIsExpanded}
        inline
        onVisibilityChange={(): void => undefined}
        onMediaTypeChange={(): void => undefined}
        className={classnames("grayjoy-layout__sidebar", {
          "grayjoy-layout__sidebar--mini": !sidebarIsExpanded
        })}
        mobileType={Drawer.DrawerTypes.TEMPORARY}
        type={
          sidebarIsExpanded
            ? Drawer.DrawerTypes.PERSISTENT
            : Drawer.DrawerTypes.PERSISTENT_MINI
        }
      >
        <div className="grayjoy-layout__content-wrapper">
          <NavList className="grayjoy-layout__sidebar-body">
            <PrimaryNavLinks
              onLinkClick={handleSidebarClick}
              primaryLinkData={primaryLinkData}
            />
            {sidebarIsExpanded && secondaryLinkData && (
              <React.Fragment>
                <li>
                  <hr />
                </li>
                <SecondaryNavLinks secondaryLinkData={secondaryLinkData} />
              </React.Fragment>
            )}
          </NavList>
          <NavList className="grayjoy-layout__sidebar-footer">
            <NavListItem
              onClick={(): void => {
                setSidebarState(!sidebarIsExpanded)
              }}
              iconName={
                sidebarIsExpanded ? "keyboard_arrow_left" : "keyboard_arrow_right"
              }
            >
              {sidebarIsExpanded ? "Collapse menu" : ""}
            </NavListItem>
          </NavList>
        </div>
      </Drawer>
      {isStatusModalOpen && (
        <ModalUpdateStatus
          shouldShowTriggerButton={false}
          shouldOpenModalByDefault={true}
          onModalOpen={handleModalOpen}
          onModalClose={handleModalClose}
        />
      )}
    </nav>
  )
}

export default SidebarNav
